<template>
    <div class="home" :style="charteVars">
        <div class="card">
            <div class="image-section">
                <img :src="homeResource" alt="Exposition" />
            </div>
            <div class="content-section">
                <h1 class="homeText" :style="textStyle" v-html="processText(homeImage.text)"></h1>
                <div class="action-section" :style="launchStyle" @click="exitHomePage">
                    <img v-if="launchImage" :src="launchImage" alt="" class="launchImage">

                    <span class="launch-text" v-html="processText(homeImage.launch_text)"></span>
                    <q-icon class="home-arrow" name="expand_more"></q-icon>
                </div>
            </div>
        </div>
    </div>
</template>



<script>
import { ref, onMounted, computed } from "vue";
import axios from "axios";
import { useRoute } from "vue-router";
import { useExhibitStyle } from "../../composables/useExhibitStyle";
import { useHomeLayout } from "../../composables/useHomeLayout";
export default {
    props: ["homeImage", "exhibitIdProps"],
    setup(props, ctx) {
        let homeResource = ref();
        const route = useRoute();
        const { cssVars, load: loadCharte } = useExhibitStyle(route.params.id ?? props.exhibitIdProps);
        const charteVars = computed(() => cssVars());
        const { textStyle, launchStyle } = useHomeLayout(() => props.homeImage);
        let exhibitId = ref();
        let launchResource = ref();
        let launchImage = ref();
        const start = async () => {
            console.log(props)
            exhibitId.value = route.params.id ?? props.exhibitIdProps;  
            loadCharte();
            await getHomeFile();
            await getLaunchResource();
            if(launchResource.value?.launch_image_id) await getLaunchFile();
        };

        const processText = (text) => {
            if (!text) return text;
            return text.replace(/\\n/g, '\n');
        };

        const exitHomePage = () => {
            ctx.emit("exit");
        }

        const getHomeFile = async () => {
            try {
                let name = props.homeImage.name;
                let url = `${process.env.VUE_APP_BASEURL}/s3Resource/${name}`;
                let response = await axios.get(url);
                var base64data = response.data;
                homeResource.value = base64data;
            } catch (error) {
                console.log(error);
            }
        };

        

        const getLaunchFile = async () => {
            try {
                let name = launchResource.value.name;
                let url = `${process.env.VUE_APP_BASEURL}/s3Resource/${name}`;
                let response = await axios.get(url);
                var base64data = response.data;
                launchImage.value = base64data;
            } catch (error) {
                console.log(error);
            }
        };
        const getLaunchResource = async ( )=>{
            try {
                let url = `${process.env.VUE_APP_BASEURL}/launchImage/${exhibitId.value}`;
                let response = await axios.get(url);
                launchResource.value = response.data[0];

            } catch (error) {
                console.log(error);
            }
        }

        onMounted(start);

        return {
            homeResource,
            exhibitId,
            launchImage,
            launchResource,
            exitHomePage,
            processText,
            charteVars,
            textStyle,
            launchStyle

        }
    }

}
</script>
<style scoped>
.home {
    display: flex;
    align-items: center;
    height: 100vh;
    background: linear-gradient(45deg, #e66465, #9198e5);  /* Gradient background for added effect */
}

.card {
    max-width: 1100px;
    width: 100%;
    margin: auto;
    overflow: hidden;
    border-radius: 20px;
    box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: row-reverse;  /* Change direction for more uniqueness */
    background: rgba(255, 255, 255, 0.9); /* Slightly transparent white for added depth */
}

.image-section {
    flex: 1.5;
    clip-path: polygon(0 0, 85% 0, 75% 100%, 0% 100%);
    overflow: hidden;
}

.image-section img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.5s; /* Smooth hover transition */
}

.image-section:hover img {
    transform: scale(1.1); /* Zoom effect on hover */
}

.content-section {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 20px;
}

.homeText {
    font-size: var(--expo-title-size, 3rem);
    color: var(--expo-title-color, #333);
    font-family: var(--expo-title-font, inherit);
    font-weight: var(--expo-title-weight, bold);
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
    margin-bottom: 2rem;
    position: relative;
    white-space: pre-line;
}

.homeText::after {  /* Decorative pseudo-element for added style */
    content: "";
    width: 80%;
    height: 6px;
    background: linear-gradient(45deg, #e66465, #9198e5);
    position: absolute;
    bottom: -10px;
    left: 10%;
}

.action-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
}

.launch-text {
    font-size: 1.5rem;
    color: #555;
    white-space: pre-line;
}

.home-arrow {
    font-size: 3rem;
    color: #555;
    cursor: pointer;
    animation: moveArrowDown 1.5s infinite alternate;
}

.launchImage{
    max-height: 100px;
    width: auto;
    object-fit: contain;
    background: transparent;
    margin-right: 8px;
}

@keyframes moveArrowDown {
    from {
        transform: translateY(0);
    }
    to {
        transform: translateY(10px);
    }
}
</style>